module.exports = {"description":"","displayName":"ProgressBar","methods":[],"props":{"progressPercentage":{"type":{"name":"number"},"required":false,"description":"Current percentage value","defaultValue":{"value":"0","computed":false}},"cssMap":{"defaultValue":{"value":"require( './progressBar.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/ProgressBar-props.json
// module id = 457
// module chunks = 0